import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { RootPaths } from '@/routes/paths';
import TokenService from '@/services/TokenService/TokenService';

type Props = {
  children: ReactNode;
};

export const AuthProtectedPage = ({ children }: Props) => {
  const token = TokenService.getTokenData();
  const isSignedIn = !!token;

  return isSignedIn ? children : <Navigate to={RootPaths.SIGN_IN} />;
};
